import React, { useEffect, useState } from "react";

import { TextField } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import CloseIcon from '@material-ui/icons/Close';
import DoneIcon from '@material-ui/icons/Done';
import { Modal } from 'react-bootstrap';
import { IDLE_TIMEOUT, RESET_INTERVAL_S } from '../constants/Constant'
import styles from '../../../pages/editors/RoadCondition.module.scss';
import './TimerModal.scss';

// const RESET_INTERVAL_S = 20; // 300s = 5m * 60s/m
const TimerModal = (props) => {
  const [timeRemain, setTimeRemain] = useState(RESET_INTERVAL_S);
  const [time, setTime] = useState(0);


  const onStay = () => {
    setTimeRemain(RESET_INTERVAL_S);
    setTime(0);
    props.onStay();
  }

  useEffect(() => {
    if (props.show) {
      const timerId = setInterval(() => {
        setTime((t) => t + 1);
      }, 1000);
      return () => clearInterval(timerId);
    }
  }, [props.show, timeRemain]);

  useEffect(() => {
    setTimeRemain(RESET_INTERVAL_S - (time % RESET_INTERVAL_S));
    if (timeRemain <= 1) {
      props.onDiscard();
    }
  }, [time]);

  const formatTime = (time) =>
    `${String(Math.floor(time / 60)).padStart(2, "0")}:${String(
      time % 60
    ).padStart(2, "0")}`;

  return (
    <>
      <Modal
        show={props.show}
        onHide={props.onHide}
        backdrop="static"
        keyboard={false}
        centered
        dialogClassName="editorsModal"
      >
        <Modal.Header>
          <Modal.Title><strong > Warning </strong>  – Your session is about to expire. Do you wish to continue working?</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>You will be logged out in : {formatTime(timeRemain)}</div>        </Modal.Body>
        <Modal.Footer>
        <Button className={styles.submitButton} variant="contained" style={{border:"2px solid #c60c30"}} color="primary" onClick={onStay}>Continue</Button>
            <div style={{ width:"2px" }}></div>
            <Button className={styles.cancelButton} variant="contained" style={{boxShadow:"0 0 0"}} color="secondary" onClick={props.onDiscard}>
            Logout
            </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
export default TimerModal;